import { css } from 'styled-components';
import { FONT_FAMILY_DISPLAY, FONT_FAMILY_TEXT, FONT_FAMILY_SYSTEM } from './constants';
import { h1, h2, h3, h4, h5, h6 } from './headings';
import { fontSizes } from './textSize';
import { theme } from './theme';
export const elements = css `
  :root {
    --font-family-text: ${FONT_FAMILY_TEXT};
    --font-family-display: ${FONT_FAMILY_DISPLAY};
    font-size: 16px;
  }

  body {
    font-family: ${theme.fontFamily.text};
    font-size: ${fontSizes.md};
    min-height: 100vh;

    &.prevent-scroll {
      overflow: hidden;
    }
  }

  .app-root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    > div,
    > header,
    > main,
    > footer {
      width: 100%;
    }

    > :not(main) {
      flex-grow: 0;
      flex-shrink: 0;
    }

    > main {
      flex-grow: 1;
    }
  }

  // Reassign text font-family for certain languages
  // See: https://hello.atlassian.net/browse/BXPT-897
  html[lang='vi'] body {
    --font-family-text: ${FONT_FAMILY_SYSTEM};
  }

  h1,
  .h1 {
    font-family: ${theme.fontFamily.display};
    ${h1}
  }
  h2,
  .h2 {
    font-family: ${theme.fontFamily.display};
    ${h2}
  }
  h3,
  .h3 {
    font-family: ${theme.fontFamily.display};
    ${h3}
  }
  h4,
  .h4 {
    font-family: ${theme.fontFamily.display};
    ${h4}
  }
  h5,
  .h5 {
    font-family: ${theme.fontFamily.display};
    ${h5}
  }
  h6,
  .h6 {
    ${h6}
  }

  p {
    margin-bottom: 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;
//# sourceMappingURL=elements.js.map